/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */
import transactionApi from '@resources/scripts/services/api/transaction.api';
import axios from 'axios';
import dayjs from 'dayjs';
import { RENEWAL_FORM } from '../mutation-types';
import { setState } from '../mutationHelpers';

const namespaced = true;

const state = {
  formFields: {
    pledgeOfEthics: false,
    programPolicies: false,
    lateFeeAcceptance: false,
    organizationId: null,

    billingFirstName: '',
    billingLastName: '',
    companyName: '',
    billingAddressLine1: '',
    billingAddressLine2: '',
    billingCity: '',
    billingState: '',
    billingZip: '',
    billingPhone: '',
    billingEmail: '',

    nameOnCard: '',
    cardNumber: '',
    cardCVV: '',
    cardExpMonth: '',
    cardExpYear: '',
    billingComments: '',
    lateFee: 0,
    renewalFee: 0,
    startRenewalDate: dayjs(),
    endRenewalDate: dayjs().add(1, 'year'),
  },
  currentPage: 1,
  submitting: false,
  submitted: false,
};

const getters = {
  transactionAmount: storeState => storeState.formFields.lateFee + storeState.formFields.renewalFee,
  formFields: storeState => storeState.formFields,
  currentPage: storeState => storeState.currentPage,
  submitting: storeState => storeState.submitting,
  submitted: storeState => storeState.submitted,
};

const mutations = {
  [RENEWAL_FORM.CHANGE_CURRENT_PAGE]: setState('currentPage'),
  [RENEWAL_FORM.TOGGLE_SUBMITTED_STATE]: setState('submitted'),
  [RENEWAL_FORM.TOGGLE_SUBMITTING_STATE]: setState('submitting'),

  [RENEWAL_FORM.FORM_FIELDS](formState, fields) {
    Object.assign(formState.formFields, fields);
  },

  [RENEWAL_FORM.UPDATE_LATE_FEE](formState, value) {
    formState.formFields.lateFee = value;
  },

  [RENEWAL_FORM.UPDATE_RENEWAL_FEE](formState, value) {
    formState.formFields.renewalFee = value;
  },
};

const actions = {
  goToNextPage({ commit }) {
    commit(RENEWAL_FORM.CHANGE_CURRENT_PAGE, state.currentPage + 1);
    window.scrollTo(0, 0);
  },

  goToPrevPage({ commit }) {
    commit(RENEWAL_FORM.CHANGE_CURRENT_PAGE, state.currentPage - 1);
    window.scrollTo(0, 0);
  },

  setLateFeeAmount({ commit }, payload) {
    commit(RENEWAL_FORM.UPDATE_LATE_FEE, payload);
  },

  setRenewalFeeAmount({ commit }, payload) {
    commit(RENEWAL_FORM.UPDATE_RENEWAL_FEE, payload);
  },

  submitForm({ commit, state: actionState, getters: formGetters }) {
    return new Promise(async (resolve, reject) => {
      commit(RENEWAL_FORM.TOGGLE_SUBMITTING_STATE, true);
      try {
        const { data: transactionData } = await transactionApi.addTransaction({
          type: 'RENEW',
          nameOnCard: actionState.formFields.nameOnCard,
          companyName: actionState.formFields.companyName,
          billingAddress1: actionState.formFields.billingAddressLine1,
          billingAddress2: actionState.formFields.billingAddressLine2,
          billingCity: actionState.formFields.billingCity,
          billingStateProvince: actionState.formFields.billingState,
          billingZip: actionState.formFields.billingZip,
          billingPhone: actionState.formFields.billingPhone,
          billingEmail: actionState.formFields.billingEmail,
          cardNumber: actionState.formFields.cardNumber,
          CardExpireMonth: actionState.formFields.cardExpMonth,
          cardExpireYear: actionState.formFields.cardExpYear,
          cVV2: actionState.formFields.cardCVV,
          comments: actionState.formFields.billingComments,
          description: 'Renewal',
          amount: formGetters.transactionAmount,
        });

        const { data: processedRenewalData } = await axios.post(`/api/transactions/${transactionData.id}/process?filemakerIdentifier=${state.formFields.organizationId}`);
        await axios.post(`/api/renewals/notification?expiration=${dayjs(state.formFields.endRenewalDate).format('MM/DD/YYYY')}&transactionId=${processedRenewalData.id}`);
        commit(RENEWAL_FORM.TOGGLE_SUBMITTED_STATE, true);
        try {
          // eslint-disable-next-line @typescript-eslint/no-angle-bracket-type-assertion
          (<any>window).gtag('config', 'UA-69171335-1', {
            page_title: 'Renewal - Submitted',
            page_path: '/forms/renewal/submitted',
          });
        } catch (error) {}
        resolve();
      } catch (error) {
        commit(RENEWAL_FORM.TOGGLE_SUBMITTING_STATE, false);
        reject(error);
      }
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};